export const REACT_APP_S3_BUCKET = process.env.REACT_APP_S3_BUCKET!;
